import React, { useState } from 'react';
import {
  Card,
  CardContent,
  Button,
  TextField,
  Typography,
  Box,
  CircularProgress,
  Snackbar,
  Paper,
} from '@material-ui/core';
import { Title, useNotify } from 'react-admin';
import { apiUrl } from '../utils/dataProvider';

const SkillsViewsReport = () => {
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState({ open: false, message: '', type: 'success' });
  const notify = useNotify();

  const handleCloseNotification = () => {
    setNotification({ ...notification, open: false });
  };

  const showNotification = (message, type = 'success') => {
    setNotification({ open: true, message, type });
  };

  const downloadReport = () => {
    if (!startDate || !endDate) {
      showNotification('Please select both start and end dates', 'error');
      return;
    }

    setLoading(true);
    
    const token = localStorage.getItem('token');
    const url = `${apiUrl}/skills/reports/skills-views-csv?startDate=${startDate}&endDate=${endDate}`;
    
    // Create request with proper headers
    fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept': 'text/csv',
      },
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`Server returned ${response.status}`);
        }
        return response.blob();
      })
      .then(blob => {
        // Create URL for download
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = `skills-views-report-${startDate}-to-${endDate}.csv`;
        
        // Append to document, click and cleanup
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
        
        notify('Report downloaded successfully', 'success');
      })
      .catch(error => {
        console.error('Download error:', error);
        notify('Failed to download report', 'warning');
        showNotification(`Failed to download report: ${error.message}`, 'error');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // Custom notification message
  const NotificationMessage = () => {
    const backgroundColor = notification.type === 'success' ? '#4caf50' : '#f44336';
    return (
      <Paper 
        style={{ 
          backgroundColor, 
          padding: '8px 16px', 
          color: 'white',
          display: 'flex',
          alignItems: 'center',
          minWidth: '300px'
        }}
      >
        <Typography variant="body2">{notification.message}</Typography>
      </Paper>
    );
  };

  return (
    <Card>
      <Title title="Skills Views Report" />
      <CardContent>
        <Typography variant="body1" paragraph>
          Сонгосон огноонуудын хооронд контент үзэлтийн тайланг үүсгэнэ.
          Тайланд courseId, category, контентын гарчиг болон нийт үзсэн минутууд багтана.
        </Typography>
        
        <Box display="flex" flexDirection="row" alignItems="center" mb={3}>
          <TextField
            label="Эхлэх огноо"
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
            inputProps={{ max: endDate || undefined }}
            fullWidth
            margin="normal"
            helperText="Огноо: YYYY-MM-DD"
          />
          
          <Box mx={2}>
            <Typography variant="body2">to</Typography>
          </Box>
          
          <TextField
            label="Дуусах огноо"
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
            inputProps={{ min: startDate || undefined }}
            fullWidth
            margin="normal"
            helperText="Огноо: YYYY-MM-DD"
          />
        </Box>

        <Typography variant="body2" paragraph style={{ marginTop: '16px', fontStyle: 'italic' }}>
          <strong>Тэмдэглэл:</strong> 2024 оны 12 сараас өмнөх тооцооллууд <a href="https://metrics.tomyo.mn/question/364-tomyo-skills-revenue-sharing-v2?startDate=2023-10-01&endDate=2023-10-31&thanSecond=300" target="_blank" rel="noopener noreferrer">энд дурдсан хувилбараар</a> тооцоологддог байсан.
        </Typography>
        
        <Button 
          variant="contained" 
          color="primary" 
          onClick={downloadReport}
          disabled={!startDate || !endDate || loading}
          startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
        >
          {loading ? 'Татаж байна...' : 'CSV татах'}
        </Button>
      </CardContent>

      <Snackbar 
        open={notification.open} 
        autoHideDuration={6000} 
        onClose={handleCloseNotification}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <NotificationMessage />
      </Snackbar>
    </Card>
  );
};

export default SkillsViewsReport; 